<template>
  <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state">
    <multiselect v-model="selected" track-by="_id" :placeholder="placeholder"
                 :options="options" :multiple="multiple" :custom-label="getLabel"
                 @input="onInput" @search-change="search" :tag-placeholder="tagPlaceholder" :taggable="true" @tag="addTag">
      <template v-slot:noResult>
        {{ $t('notFoundSearch') }}
      </template>
      <template v-slot:noOptions>
        {{ $t('notFoundSearch') }}
      </template>
    </multiselect>
  </b-form-group>
</template>

<script>
import _ from 'lodash';
import list from '@/mixins/List';
import i18n from '@/i18n';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  props: {
    model: Object,
    attribute: {
      type: String,
      default: 'ccEmail'
    },
    label: String,
    errors: Array,
    placeholder: {
      type: String,
      default: 'To cc email'
    },
    tagPlaceholder: {
      type: String,
      default: i18n.t('addEmail')
    },
    multiple: Boolean,
    isFilter: Boolean
  },
  components: {Multiselect},
  mixins: [list],
  data() {
    return {
      selected: [],
      state: null,
      errorTxt: '',
      options: [],
      showList: false,
      service: 'email/all',
      autoLoad: false,
      defaultFilterFormModel: {
        keyword: '',
      },
      focused: false,
      changeTrigger: true,
    }
  },
  watch: {
    model: {
      handler(val) {
        this.state = null;
        this.errorTxt = '';

        if (val[this.attribute] != null) {
          if (this.changeTrigger) {
            this.loadSelected();
          }
          this.changeTrigger = true;
        } else {
          this.selected = null;
        }
      }, deep: true
    },
    // selected(val) {
    // this.changeTrigger = false;
    // if (val === null) {
    //   this.model[this.attribute] = val;
    // } else if (this.multiple) {
    //   this.model[this.attribute] = val.map(s => s._id);
    // } else {
    //   this.model[this.attribute] = val._id;
    // }
    // },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
          }
        });
      }
      this.state = !hasErr;
    }
  },
  methods: {
    addTag (newTag) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(re.test(String(newTag).toLowerCase())){
        let tag = {
                  _id: newTag
              }
        this.options.push(tag);
        // this.selected.push(tag);
        this.model[this.attribute].push(newTag);
      }
    },
    onInput() {
      let val = this.selected;
      this.changeTrigger = false;
      if (val === null) {
        this.model[this.attribute] = val;
      } else if (this.multiple) {
        // console.log(this.model[this.attribute]);
        this.model[this.attribute] = val.map(s => s._id);
      } else {
        this.model[this.attribute] = val._id;
      }
      this.$emit('change');
    },
    getLabel({_id}) {
      return `${_id}`;
    },
    search: _.debounce(function (event) {
      this.filterFormModel.keyword = event;
      this.filterFormModel.page = 1;
      this.load();
    }, 250),
    loadSelected() {
      if (this.model[this.attribute]) {
        let ids;
        if (this.multiple) {
          ids = this.model[this.attribute].join(',');
        } else {
          ids = this.model[this.attribute];
        }
        if (ids) {
          this.$bgService.get('email/emailSelected', {
            params: {page: 1, pageSize: 200, ids: ids}
          }).then(response => {
            // console.log(response);
            if (this.multiple) {
              this.selected = response.data;
            } else if (response.data) {
              // console.log(response.data);
              this.selected = response.data;
            }
          }).catch(error => {
                if (error.response.data.message) {
                    this.$swal({
                        text: error.response.data.message,
                        icon: 'error'
                    });
                }
            });
        }
      }
    },
    load(){
        let loadingDelay = _.delay(() => {
                this.listLoading = true;
            }, 250);
            this.$service.get(this.service, {
                params: this.filterFormModel
            }).then(response => {
                this.options = response.data;
            }).catch(error => {
                if (error.response.data.message) {
                    this.$swal({
                        text: error.response.data.message,
                        icon: 'error'
                    });
                }
            }).finally(() => {
                clearTimeout(loadingDelay);
                this.listLoading = false;
                if(this.afterLoad){
                    this.afterLoad();
                }
            });
    }
  },
  mounted() {
    this.selected = null;
    this.loadSelected();
    this.load();
  }
}
</script>